import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { Brain, Battery, Moon, ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../../hooks/useMetaPixel';
export function SolutionSection() {
  const benefits = [{
    icon: Battery,
    title: 'Drenar la ansiedad física',
    description: 'Baja tus pulsaciones y elimina la tensión muscular en segundos, no en horas.'
  }, {
    icon: Brain,
    title: 'Eliminar la neblina mental',
    description: 'Recupera tu claridad cognitiva sin cafeína ni estimulantes artificiales.'
  }, {
    icon: Moon,
    title: 'Dormir como un profesional',
    description: 'Desconecta tu cerebro al final del día aunque tu agenda haya sido un caos.'
  }];
  return <Section background="white" data-id="element-247">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-248">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-249">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-charcoal-dark mb-6" data-id="element-250">
            El Protocolo{' '}
            <span className="text-brand-gold-dark" data-id="element-251">Cortisol Off</span>
          </h2>
          <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-252">
            La mayoría de la gente te dirá que medite, que se tome un año
            sabático o que haga yoga. Pero eres emprendedor. Tienes facturas que
            pagar y metas que cumplir. No tienes tiempo para retiros
            espirituales.
          </p>
          <p className="text-lg text-brand-charcoal/80 mb-8 leading-relaxed font-medium" data-id="element-253">
            Por eso creé el Protocolo Cortisol Off. No es un libro de autoayuda.
            Es un manual operativo de 7 minutos para resetear tu sistema
            nervioso biológicamente mientras estás frente a tu laptop.
          </p>

          <div className="space-y-6" data-id="element-254">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-255">
                <div className="bg-brand-cream-dark p-3 rounded-full" data-id="element-256">
                  <benefit.icon className="h-6 w-6 text-brand-gold-dark" data-id="element-257" />
                </div>
                <div data-id="element-258">
                  <h4 className="text-lg font-bold text-brand-charcoal-dark" data-id="element-259">
                    {benefit.title}
                  </h4>
                  <p className="text-brand-charcoal/70" data-id="element-260">
                    {benefit.description}
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative px-4 sm:px-0" data-id="element-261">
          <div className="aspect-[4/5] rounded-lg overflow-hidden shadow-2xl relative z-10" data-id="element-262">
            <div className="w-full h-full bg-brand-charcoal-dark flex flex-col items-center justify-center p-8 text-center border-8 border-brand-gold/20" data-id="element-263">
              <h3 className="text-brand-gold font-serif text-4xl mb-2" data-id="element-264">
                Cortisol Off
              </h3>
              <p className="text-brand-cream/60 uppercase tracking-widest text-sm" data-id="element-265">
                Manual Operativo
              </p>
              <div className="w-16 h-1 bg-brand-gold mt-8 mb-8" data-id="element-266"></div>
              <p className="text-brand-cream/80 font-serif italic" data-id="element-267">
                "El interruptor biológico que tus competidores no conocen."
              </p>
            </div>
          </div>
          {/* Decorative elements — hidden on mobile to prevent overflow */}
          <div className="hidden sm:block absolute -top-4 -right-4 w-full h-full border-2 border-brand-gold/30 rounded-lg -z-0" data-id="element-268"></div>
          <div className="hidden sm:block absolute -bottom-4 -left-4 w-full h-full bg-brand-sage/10 rounded-lg -z-10" data-id="element-269"></div>

          {/* CTA Buttons */}
          <div className="flex flex-col gap-3 mt-8 relative z-10" data-id="element-270">
            <Button size="lg" className="w-full text-base sm:text-lg shadow-lg shadow-brand-gold/20" onClick={() => {
            trackAddToCart();
            window.open('https://pay.hotmart.com/K104693298R?off=hiid2a6g', '_blank');
          }} data-id="element-271">
              Obtener Acceso Inmediato <ArrowRight className="ml-2 h-5 w-5" data-id="element-272" />
            </Button>
            <Button size="md" variant="outline" className="w-full text-base" onClick={() => {
            trackAddToCart();
            window.open('https://thehabitbalance.com/cart/51805726671131:1', '_blank');
          }} data-id="element-273">
              Checkout seguro
            </Button>
          </div>
        </motion.div>
      </div>
    </Section>;
}